import styled from 'styled-components'

export const LoaderStyle = styled.div`
  height: 100vh;
  width: 100vw;
  background: #151515;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 1em;
  text-align: center;

  .loaderText {
    color: #c7c5c4;
    margin-top: 14px;

    .dot {
      animation: 1s blink infinite;
    }
    .dot:nth-child(2) {
      animation-delay: 250ms;
    }
    .dot:nth-child(3) {
      animation-delay: 500ms;
    }
    .dot:nth-child(4) {
      animation-delay: 750ms;
    }
    .dot:nth-child(5) {
      animation-delay: 900ms;
    }
  }

  .loader {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-block;
    border-top: 4px solid #c7c5c4;
    border-right: 4px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  .loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border-left: 4px solid #951d30;
    border-bottom: 4px solid transparent;
    animation: rotation 0.5s linear infinite reverse;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes blink {
    50% {
      color: transparent;
    }
  }
`
